import { useMutation } from "@tanstack/react-query";
import { putCustomerInfo } from "../api/customer";

const usePutCustomerInfo = () => {
  const mutation = useMutation({
    mutationFn: putCustomerInfo,
  });
  return mutation;
};

export default usePutCustomerInfo;
